import { openURL } from "../../../utils/sideEffects";

export const handleFeedbackPress = (): Promise<void> => {
  const feedbackUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSdKDaYchJ-g8Ly2xMAXb-PDRVG47yEHG1EVL8XdQVB7_a1a3Q/viewform?usp=sf_link";
  return openURL(feedbackUrl);
};
